import { type FC, type ReactNode, useCallback } from "react";
import { Sidebar, UIFloatingPortal } from "@onshopfront/components";
import { useShopfrontDispatch, useShopfrontSelector } from "../../_Bootstrap/hooks";
import { LAYOUT_TOGGLE_MENU } from "../../Actions/General/LayoutActions";
import { fireEventType } from "../../Utilities/Generic/ActionsHelper";
import { uppercaseFirst } from "../../Utilities/Generic/Strings";
import { useShowMenu } from "../../Utilities/Hooks/ShowMenu";
import { getOption } from "../../Utilities/Platform/Options/Options";

interface Props {
    items: ReactNode;
}

export const NAVIGATION_USER_UPDATE = "navigationUserUpdate";

export const Navigation: FC<Props> = ({ items }) => {
    const dispatch = useShopfrontDispatch();

    const forceMenu = useShowMenu();
    const open = useShopfrontSelector(state => state.layout.menu.open);

    const showNavigation = forceMenu || open;

    const onClose = useCallback(() => {
        dispatch(fireEventType(LAYOUT_TOGGLE_MENU));
    }, [ dispatch ]);

    return (
        <UIFloatingPortal>
            <Sidebar
                open={showNavigation}
                onClose={showNavigation ? onClose : undefined}
                side="left"
                className="z-1 bg-white dark:bg-dark-900"
                wrapperClassName="flex flex-col md:w-[500px] w-screen max-w-full h-full"
                showOverlay={!forceMenu && open}
                top={50}
            >
                <nav className="flex flex-col w-full h-full pointer-events-auto">
                    {items}
                    <div className="text-xs pb-4 px-8 text-neutral-400 dark:text-neutral-500">
                        <div>Channel: {uppercaseFirst(__VERSION__.channel)}</div>
                        <div>Version: {__VERSION__.commit}</div>
                        <div>Device: {getOption("_instance_id")}</div>
                    </div>
                </nav>
            </Sidebar>
        </UIFloatingPortal>
    );
};
